export const getStorageJSON = (key) => {
  if (typeof window !== 'undefined' && localStorage.getItem(key)) {
    return JSON.parse(localStorage.getItem(key))
  }

  return null
}

export const getStorage = (key) => {
  if (typeof window !== 'undefined' && localStorage.getItem(key)) {
    return localStorage.getItem(key)
  }

  return null
}

export const setStorage = (key, value) => {
  if (typeof window !== 'undefined') {
    return localStorage.setItem(key, value)
  }
  return null
}

export const setStorageJSON = (key, data) => {
  if (typeof window !== 'undefined') {
    return localStorage.setItem(key, JSON.stringify(data))
  }
  return null
}

export const removeStorage = (key) => {
  if (typeof window !== 'undefined') {
    return window.localStorage.removeItem(key)
  }
  return null
}
